import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAttached = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 490 1024",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M422.957 256.007v471.038c0 93.050-68.118 175.861-160.723 184.765-106.407 10.24-195.45-73.016-195.45-177.197v-550.286c0-58.323 41.85-111.304 99.729-117.092 66.783-6.678 122.88 45.412 122.88 110.859v467.476c0 24.487-20.035 44.522-44.522 44.522s-44.522-20.035-44.522-44.522v-389.563c0-18.254-15.137-33.391-33.391-33.391s-33.391 15.137-33.391 33.391v383.33c0 58.323 41.85 111.304 99.729 117.092 66.783 6.678 122.88-45.412 122.88-110.859v-459.907c0-93.050-68.118-175.861-160.723-184.765-105.962-10.24-195.45 73.016-195.45 177.197v546.28c0 127.777 93.496 242.198 220.828 254.219 146.477 13.357 268.911-100.619 268.911-243.979v-478.606c0-18.254-15.137-33.391-33.391-33.391s-33.391 15.137-33.391 33.391z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgAttached);
export default ForwardRef;
